import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const resultService = {
  getAll,
  createOrUpdate,
  deleteResult
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/results/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newResult) {
  const requestOptions = {
    method: newResult.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newResult)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/results${
    newResult.id ? `/${newResult.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(result) {
  let formData = new FormData();

  formData.append('result[title]', result.title);
  formData.append('result[date]', result.date);
  formData.append('result[description]', result.description);
  const document = result.document;

  if (document) {
    if (document.url) {
      formData.append(`result[document]`, document.url);
    } else {
      formData.append(`result[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteResult(resultId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/results/${resultId}`;

  return axios.delete(url, requestOptionsDelete);
}
